module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_13-1cfb3a9b6bc8f0ffa128c1197ba94067.png";